import { useRef } from "react";
import {
    motion,
    useScroll,
    useTransform,
    useSpring,
} from "framer-motion";

import "../../asstes/styles/whyBhupendra.scss";
import whyBhupendra from "../../asstes/images/private-council/why-bhupendra.jpg";
const PrivateCouncilWhyBhupendra = () => {

    const sectionRef = useRef(null);

    const { scrollYProgress } = useScroll({
        target: sectionRef,
        offset: ["start end", "end start"],
    });

    const smooth = useSpring(scrollYProgress, {
        stiffness: 80,
        damping: 22,
        mass: 0.4,
    });

    const imageY = useTransform(smooth, [0, 1], [-80, 80]);

    const imageScale = useTransform(
        smooth,
        [0, 0.5, 1],
        [1.15, 1, 1.05]
    );

    const imageRotate = useTransform(
        smooth,
        [0, 1],
        [-3, 3]
    );

    const titleY = useTransform(
        smooth,
        [0.1, 0.5],
        [100, 0]
    );

    const titleOpacity = useTransform(
        smooth,
        [0.1, 0.45],
        [0, 1]
    );

    const textY = useTransform(
        smooth,
        [0.2, 0.6],
        [60, 0]
    );

    const textOpacity = useTransform(
        smooth,
        [0.2, 0.55],
        [0, 1]
    );

    const glowOpacity = useTransform(
        smooth,
        [0.1, 0.5, 1],
        [0, 0.7, 0.3]
    );

    return (
        <section
            ref={sectionRef}
            className="why-bhupendra-section"
        >

            <motion.div
                style={{
                    opacity: glowOpacity
                }}
                className="bg-glow"
            />

            <div className="container">
                <div className="row align-items-center gy-5">

                    {/* IMAGE */}
                    <div className="col-lg-5">
                        <div className="why-image-wrapper">

                            <motion.div
                                style={{
                                    y: imageY
                                }}
                                className="image-inner"
                            >
                                <motion.img
                                    src={whyBhupendra}
                                    alt="Bhupendra"
                                    className="main-image"
                                    style={{
                                        scale: imageScale,
                                        rotate: imageRotate
                                    }}
                                />
                            </motion.div>

                            <div className="image-border"></div>

                        </div>
                    </div>

                    {/* CONTENT */}
                    <div className="col-lg-7">

                        <motion.div
                            style={{
                                y: titleY,
                                opacity: titleOpacity
                            }}
                            className="content-area"
                        >

                            <div className="section-tag">
                                <span></span>
                                THE CONVENER
                            </div>

                            <h2 className="main-title">
                                <span>Why</span> Bhupendra
                            </h2>

                        </motion.div>

                        <motion.div
                            style={{
                                y: textY,
                                opacity: textOpacity
                            }}
                        >
                            <p className="description">
                                Bhupendra Chaudhary has navigated
                                decisions where consequences were
                                immediate and irreversible, often
                                in silence, always by discipline.
                            </p>

                            <p className="description secondary">
                                He brings pattern recognition,
                                systemic intelligence and
                                accumulated insight into the
                                nervous system and the decision process.
                            </p>

                            <div className="quote-box">
                                The Private Council is the form
                                through which he convenes,
                                clearly and privately.
                            </div>
                        </motion.div>

                    </div>

                </div>
            </div>
        </section>
    );
};

export default PrivateCouncilWhyBhupendra;